import { FC } from 'react'

import { ErrorRouteComponent, useParams } from '@tanstack/react-router'

import { Spinner } from '@forto-dev/phoenix-ui-core/common'
import { Layout, LayoutProps } from '@forto-dev/phoenix-ui-core/ship'

import { Back } from '@/fragments/back.tsx'
import { createErrorFallback } from '@/fragments/create-error-fallback.tsx'
import { Footer } from '@/fragments/footer.tsx'
import { Header } from '@/fragments/header.tsx'

export const BookingPendingLayout: FC = () => {
  return (
    <Layout header={<Header />} navigation={<Back to="/" search />} main={<Spinner size="lg" />} footer={<Footer />} />
  )
}
export const BookingErrorComponent: ErrorRouteComponent = ({ error, reset }) => {
  const { id } = useParams({
    from: '/bookings/$id',
  })
  return (
    <Layout
      header={<Header />}
      navigation={<Back to="/" search />}
      main={createErrorFallback(`An error occurred while loading booking ${id}`)({ error, reset })}
      footer={<Footer />}
    />
  )
}

type PartialByKeys<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>
type BookingOverviewTabLayoutProps = PartialByKeys<LayoutProps, 'header' | 'navigation' | 'footer'> & {
  bookingId: string
}
export const BookingOverviewTabLayout: FC<BookingOverviewTabLayoutProps> = ({ bookingId, ...rest }) => {
  return (
    <Layout
      header={<Header />}
      navigation={<Back to="/bookings/$id" search params={{ id: bookingId }} />}
      footer={<Footer />}
      {...rest}
    />
  )
}
